import {TemperatureSensorHelperModel} from "../temperature-sensor-helper-model";

export class SensorsTemperatureModel {
  temperatureSensorsHelperList: TemperatureSensorHelperModel[];

  constructor() {
    this.temperatureSensorsHelperList = [];
  }

  public static initialize(model: SensorsTemperatureModel): void {
    if (!model.temperatureSensorsHelperList) {
      model.temperatureSensorsHelperList = [];
    }
  }
}
